// src/App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import LoginPage         from './pages/LoginPage';
import DashboardPage     from './pages/DashboardPage';
import SettingsPage      from './pages/SettingsPage';
import ItemsPage         from './pages/ItemsPage';
import BillsPage         from './pages/BillsPage';
import BillDetailPage    from './pages/BillDetailPage';
import DailyReportPage   from './pages/DailyReportPage'; // ← import here
import ProtectedRoute    from './components/ProtectedRoute';
import Navbar            from './components/Navbar';
import ReceiptPrinter    from './components/ReceiptPrinter';
import ItemsPrinter  from './pages/ItemsPrinter';
import Footer from './components/Footer';
function App() {
  return (
    <div>
      <Navbar />

      <Routes>
        {/* Public */}
        <Route path="/login" element={<LoginPage />} />

        {/* Dashboard (any logged‐in role) */}
        <Route
          path="/"
          element={
            <ProtectedRoute roles={['cashier', 'manager', 'admin']}>
              <DashboardPage />
            </ProtectedRoute>
          }
        />

        {/* Settings (admin only) */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute roles={['admin']}>
              <SettingsPage />
            </ProtectedRoute>
          }
        />

        {/* Items (manager or admin) */}
        <Route
          path="/items"
          element={
            <ProtectedRoute roles={['manager', 'admin']}>
              <ItemsPage />
            </ProtectedRoute>
          }
        />

        {/* Bills list (cashier/manager/admin) */}
        <Route
          path="/bills"
          element={
            <ProtectedRoute roles={['cashier', 'manager', 'admin']}>
              <BillsPage />
            </ProtectedRoute>
          }
        />

        {/* Single‐bill detail */}
        <Route
          path="/bills/:billId"
          element={
            <ProtectedRoute roles={['cashier', 'manager', 'admin']}>
              <BillDetailPage />
            </ProtectedRoute>
          }
        />

        {/* Bill printing */}
        <Route
          path="/bills/:billId/print"
          element={
            <ProtectedRoute roles={['cashier', 'manager', 'admin']}>
              <ReceiptPrinter />
            </ProtectedRoute>
          }
        />

        {/* Daily Report (manager and admin only) */}
        <Route
          path="/bills/report/daily"
          element={
            <ProtectedRoute roles={['manager', 'admin']}>
              <DailyReportPage />
            </ProtectedRoute>
          }
        />
        <Route path="/items/print" element={<ItemsPrinter />} />

        {/* Fallback → go to Dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {/* <Footer /> */}
    </div>
  );
}

export default App;
